import React, {useContext, useEffect, useRef} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import TextsContext from "../../TextsContent";
import "./waterChallenge.css";
import Routes from "../../assets/RoutesToPages/Routes";

const WaterChallenge = () => {
  const texts = useContext(TextsContext);
  const location = useLocation();
  const {choicedChallenge, chosenChallengeDaysAmount, allChallenges} = location.state || {};
  let chosenAutocompletedChallenge = choicedChallenge.concat('Autocompleted');
  const navigate = useNavigate();
  const challengeContainerRef = useRef(null);
  const timerFadeIn = useRef(null);


  useEffect(() => {
    if (challengeContainerRef.current) {
      challengeContainerRef.current.classList.add('challenge-container-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      challengeContainerRef.current.classList.remove('challenge-container-fade-in');
    }, 350);

    window.scrollTo({top: 0, behavior: 'smooth'});

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  const handleChallenge = () => {
    const savedValue = localStorage.getItem("autocomplete_challenges");
    let savedChallenges;
    try {
      savedChallenges = JSON.parse(savedValue);
      if (typeof savedChallenges !== "object" || savedChallenges === null) {
        savedChallenges = {};
      }
    } catch (e) {
      savedChallenges = {};
    }

    savedChallenges[chosenAutocompletedChallenge] = false;
    const challengeAutoUpdating = {
      'lactoseFreeDaysChallengeProgressType': savedChallenges.lactoseFreeDaysAutocompleted,
      'noSugarDaysChallengeProgressType': savedChallenges.noSugarDaysAutocompleted,
      'soberDaysChallengeProgressType': savedChallenges.soberDaysAutocompleted,
    };
    localStorage.setItem('challengeAutoUpdating', JSON.stringify(challengeAutoUpdating));
    localStorage.setItem(
      "autocomplete_challenges",
      JSON.stringify(savedChallenges)
    );

    const isBegunChallengesData = JSON.parse(localStorage.getItem('isBegun'));
    localStorage.setItem('isBegun', JSON.stringify({
        ...isBegunChallengesData,
        [chosenAutocompletedChallenge]: true
      }
    ));

    navigate(Routes.waterChallengeOpen, {
      state: {
        choicedChallenge: choicedChallenge,
        chosenChallengeDaysAmount: chosenChallengeDaysAmount,
        allChallenges: allChallenges,
        chosenAutocompletedChallenge: chosenAutocompletedChallenge,
      },
    });
  };

  const waterChallengeContent = [
    {
      id: 1,
      image: require("./img/calm.png"),
      description: texts.water[choicedChallenge]["calm_text"],
    },
    {
      id: 2,
      image: require("./img/flower.png"),
      description: texts.water[choicedChallenge]["flower_text"],
    },
    {
      id: 3,
      image: require("./img/star.png"),
      description: texts.water[choicedChallenge]["star_text"],
    },
    {
      id: 4,
      image: require("./img/butterfly.png"),
      description: texts.water[choicedChallenge]["butterfly_text"],
    },
  ];

  return (
    <div ref={challengeContainerRef}
         className="main-container water-challenge">
      <div className="outer-content">
        <img
          className="main-logo"
          alt="logo"
          src={require("../../assets/img/avo-bottle.png")}
        />
        <p className="main-text">{texts.water["main-text"]}</p>
      </div>
      <div className="inner-content">
        <div className="workout-navigation">
          <img
            className="workout-navigation__arrow"
            onClick={() => navigate(-1)}
            src={require("../../assets/img/back_arrow.svg").default}
            width="24"
            height="24"
            alt="image arrow left"
          ></img>

          <h2 className="water-challenge__title">
            {texts.water[choicedChallenge]["opened_box_title"]}
          </h2>
        </div>

        <div className="water-challenge__content">
          {waterChallengeContent
            .filter(
              (item) => item.description && item.description.trim() !== "")
            .map((waterChallengeContentItem) => (
              <div
                key={waterChallengeContentItem.id}
                className="water-challenge__item"
              >
                <div className="water-challenge__item-icon">
                  <img src={waterChallengeContentItem.image} alt="text icon"/>
                </div>
                <p className="water-challenge__item-description">
                  {waterChallengeContentItem.description}
                </p>
              </div>
            ))}
        </div>

        <button onClick={handleChallenge} className="water-challenge_start">
          {texts.water["start"]}
        </button>
      </div>
    </div>
  );
};

export default WaterChallenge;
